













import JourneyParameters from '@/models/interfaces/JourneyParameters';
import SurveyAnswer from '@/models/SurveyAnswer';
import { Rating } from '@solucx/indicators';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

@Component
export default class AcceptanceContactIfDetractor extends Vue {
  @Prop() public value: boolean;
  @Prop() public rating: SurveyAnswer;
  @Prop({ required: true }) public readonly parameters: JourneyParameters;

  public get acceptanceContactIfDetractor(): boolean {
    return this.value;
  }

  public set acceptanceContactIfDetractor(value: boolean) {
    this.$emit('input', value);
  }

  public get shouldContactIfDetractor(): boolean {
    return this.isDetractor && this.parameters.showAcceptanceContactIfDetractor === true;
  }

  public get isDetractor(): boolean {
    return this.rating.getRating() === Rating.NEGATIVE;
  }

  public get customAcceptanceContactText(): string {
    const { customAcceptanceContactText } = this.parameters;
    return customAcceptanceContactText ? customAcceptanceContactText : this.$tc('generic.acceptanceContact');
  }

  @Watch('shouldContactIfDetractor')
  public onChangedActiveContactIfDetractor(): void {
    this.$emit('shouldContactIfDetractorChanged');
  }
}
